import React from 'react';
import {Iap} from '../../../backend/model';
import {compareNumericString} from '../../../utils/sorting';
import {IapLink} from '../../TableItemLink';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';

const TABLE_ID = 'iogPage-iapsTable'

const COLUMN_DEFINITIONS = [
    {
        id: 'iapId',
        header: 'IAP',
        cell: (iap: Iap): JSX.Element => <IapLink iapId={iap.iapId}/>,
        sortingComparator: (a: Iap, b: Iap): number => compareNumericString(a.iapId, b.iapId),
    },
    {
        id: 'iapName',
        header: 'Name',
        cell: (iap: Iap): string => iap.iapName,
        sortingField: 'iapName'
    },
]

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'IAP',
        key: 'iapId',
        groupValuesLabel: 'IAP ID values',
        operators: operators,
    },
    {
        propertyLabel: 'Name',
        key: 'iapName',
        groupValuesLabel: 'Name values',
        operators: operators,
    },
]

const IapTable: React.FC<TableInput> = ({tableItems, fileName}): JSX.Element => {
    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: `Supplies ${tableItems.length} IAPs`,
        fileName: fileName,
        getRow: function (row: any): string[] {
            return [row.iapId, row.iapName]
        }
    }
    return useTableCreation(tableDetails, COLUMN_DEFINITIONS, tableItems, FILTERING_PROPERTIES)
}

export default IapTable
